import React, { ReactNode, useState } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

interface StripeWrapperProps {
  children: ReactNode;
}

let stripePromise: Promise<Stripe | null> | null = null;

const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");
  }
  return stripePromise;
};

const StripeWrapper: React.FC<StripeWrapperProps> = ({ children }) => {
  const [stripePromiseState] = useState<Promise<Stripe | null>>(() => {
    return getStripePromise();
  });

  const options = {
    appearance: {
      theme: 'stripe' as const,
      variables: {
        colorPrimary: '#0F428D',
        colorBackground: '#ffffff',
        colorText: '#1f2937',
        colorDanger: '#ef4444',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
      rules: {
        '.Input': {
          border: '2px solid #e5e7eb',
          borderRadius: '8px',
          padding: '12px',
          fontSize: '16px',
        },
        '.Input:focus': {
          border: '2px solid #0F428D',
          boxShadow: '0 0 0 2px rgba(15, 66, 141, 0.1)',
        },
        '.Label': {
          fontSize: '14px',
          fontWeight: '500',
          color: '#1f2937',
          marginBottom: '6px',
        },
      },
    },
  };

  return (
    <Elements stripe={stripePromiseState} options={options}>
      {children}
    </Elements>
  );
};

export default StripeWrapper;
